import { Navigate } from 'react-router-dom';

import { checkRouteAccess } from '@/config/auth/routeAccess';
import { useAccess } from '@/entities/user/providers/useAccess';

/**
 * Post-login landing target (also the unknown-path fallback): Reported Jobs
 * when the user may view jobs, the universally-open profile otherwise.
 */
export function LandingRedirect() {
  const { user } = useAccess();
  const target = checkRouteAccess('/jobs', user) ? '/jobs' : '/profile/overall';
  return <Navigate to={target} replace />;
}
